/**
 * 네온 장거리 (classic-night)
 *
 * 이 파일은 tools/derive-classic-maps.mjs 가 만든다. 손으로 고치지 말고 그 스크립트를 고쳐라.
 * 원본: lazygyu/roulette (MIT) 커밋 47230e32242e1c82030eacb4a263420fe95cedb6 의 src/data/maps.ts — "Yoru ni Kakeru (by item4)"
 * 자세한 출처와 라이선스는 THIRD_PARTY_NOTICES.md 를 보라.
 */

import type { MapDefinition } from '../map/types.ts';

export const classicNight: MapDefinition = {
  id: "classic-night",
  version: 1,
  name: "네온 장거리",
  category: 'classic',
  description: "긴 다단 코스를 따라 여러 색 회전 막대와 원형 장애물 군집, 경사로가 이어진다. 여덟 맵 가운데 가장 길다.",
  highlights: ["긴 다단 코스","여러 색 회전 막대","원형 장애물 군집","연속 경사로"],
  origin: {"originalTitle":"Yoru ni Kakeru (by item4)","note":"긴 코스의 구간 순서와 장애물 군집 배치를 계승했다."},
  bounds: {"x":0,"y":-20,"w":24,"h":275},
  preview: {"x":1,"y":-8,"w":22,"h":262},
  spawn: {"area":{"x":8.2,"y":-8,"w":6.6,"h":10},"perRow":10,"gap":0.62},
  finish: { area: {"x":0,"y":248,"w":24,"h":6} },
  checkpoints: [{"id":"cp1","name":"첫 핀 구간","area":{"x":0,"y":30,"w":24,"h":2}},{"id":"cp2","name":"원형 장애물 군집","area":{"x":0,"y":70,"w":24,"h":2}},{"id":"cp3","name":"중반 회전 막대","area":{"x":0,"y":110,"w":24,"h":2}},{"id":"cp4","name":"후반 군집","area":{"x":0,"y":150,"w":24,"h":2}},{"id":"cp5","name":"마지막 회전 발판","area":{"x":0,"y":200,"w":24,"h":2}},{"id":"cp6","name":"결승 직선","area":{"x":0,"y":240,"w":24,"h":2}}],
  estimatedDurationSec: [20,37],
  timeLimitSec: 240,
  progressPath: [
    [11.5,-8],
    [11.5,-2],
    [11.5,4],
    [11.5,10],
    [11.5,16],
    [11.5,22],
    [11.5,28],
    [11.5,34],
    [11.5,40],
    [11.5,46],
    [11.5,52],
    [11.5,58],
    [11.5,64],
    [11.5,70],
    [11.5,76],
    [11.5,82],
    [11.5,88],
    [11.5,94],
    [11.5,100],
    [11.5,106],
    [11.5,112],
    [11.5,118],
    [11.5,124],
    [11.5,130],
    [11.5,136],
    [11.5,142],
    [11.5,148],
    [11.5,154],
    [11.5,160],
    [11.5,166],
    [11.5,172],
    [11.5,178],
    [11.5,184],
    [11.5,190],
    [11.5,196],
    [11.5,202],
    [11.5,208],
    [11.5,214],
    [11.5,220],
    [11.5,226],
    [11.5,232],
    [11.5,238],
    [11.5,244],
    [11.5,250],
  ],
  obstacles: [
    {"t":"box","x":2,"y":0,"hw":1,"hh":800,"angle":0,"style":"box","restitution":0},
    {"t":"box","x":21,"y":0,"hw":1,"hh":800,"angle":0,"style":"box","restitution":0},
    {"t":"box","x":4,"y":25,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":1},
    {"t":"box","x":4,"y":30,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":4,"y":35,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":4,"y":40,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":9,"y":25,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":9,"y":30,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":9,"y":35,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":9,"y":40,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":14,"y":25,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":14,"y":30,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":14,"y":35,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":14,"y":40,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":19,"y":25,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":19,"y":30,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":19,"y":35,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":19,"y":40,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"circle","x":10,"y":26,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":26,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13,"y":26,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10,"y":27.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":27.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13,"y":27.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10,"y":29,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":29,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13,"y":29,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5,"y":31,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":31,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8,"y":31,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5,"y":32.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":32.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8,"y":32.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5,"y":34,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":34,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8,"y":34,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15,"y":31,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":31,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18,"y":31,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15,"y":32.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":32.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18,"y":32.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15,"y":34,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":34,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18,"y":34,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10,"y":36,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":36,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13,"y":36,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10,"y":37.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":37.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13,"y":37.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10,"y":39,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":39,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13,"y":39,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.5,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.5,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18.5,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":20,"y":60,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4.5,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":7.5,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10.5,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13.5,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":63,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.5,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.5,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18.5,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":20,"y":66,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"box","x":3.8,"y":90,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":19.2,"y":90,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":5.8,"y":92,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":17.2,"y":92,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":7.8,"y":94,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":15.2,"y":94,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":9.8,"y":96,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":13.2,"y":96,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":3.8,"y":94,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":19.2,"y":94,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":5.8,"y":96,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":17.2,"y":96,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":7.8,"y":98,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":15.2,"y":98,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":9.8,"y":100,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":13.2,"y":100,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"circle","x":10,"y":90,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12,"y":90,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8,"y":92,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14,"y":92,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6,"y":94,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16,"y":94,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4,"y":96,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18,"y":96,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10,"y":94,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12,"y":94,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8,"y":96,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14,"y":96,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6,"y":98,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16,"y":98,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4,"y":100,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18,"y":100,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"box","x":3.8,"y":104,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":19.2,"y":104,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":5.8,"y":106,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":17.2,"y":106,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":7.8,"y":108,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":15.2,"y":108,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":9.8,"y":110,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":13.2,"y":110,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":3.8,"y":108,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":19.2,"y":108,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":5.8,"y":110,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":17.2,"y":110,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":7.8,"y":112,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":15.2,"y":112,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":9.8,"y":114,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"box","x":13.2,"y":114,"hw":0.1,"hh":0.1,"angle":-2.035,"style":"box","restitution":0},
    {"t":"circle","x":3.5,"y":105,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":105,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":107,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":107,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":107,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":107,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":109,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":109,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":109,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":109,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":7.5,"y":109,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":109,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":115,"r":0.4,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":115,"r":0.4,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":115,"r":1.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":115,"r":1.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":115,"r":2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":115,"r":2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":115,"r":2.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":115,"r":2.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":115,"r":3.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":115,"r":3.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":120,"r":0.4,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":120,"r":1.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":120,"r":2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":120,"r":2.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":120,"r":3.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":7.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":135,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":7.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":140,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":7.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":144,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":7.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":147,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":7.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":149,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":3.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":4.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":5.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":6.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":7.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":8.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":16.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":17.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":18.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":19.5,"y":150,"r":0.2,"pop":true,"style":"bubble","restitution":1.5},
  ],
  devices: [
    {"t":"spinner","x":6.5,"y":27.5,"hw":2,"hh":0.1,"omega":2,"angle":0,"style":"bar"},
    {"t":"spinner","x":6.5,"y":37.5,"hw":2,"hh":0.1,"omega":2,"angle":0,"style":"bar"},
    {"t":"spinner","x":11.5,"y":32.5,"hw":2,"hh":0.1,"omega":4,"angle":0,"style":"bar"},
    {"t":"spinner","x":16.5,"y":27.5,"hw":2,"hh":0.1,"omega":-2,"angle":0,"style":"bar"},
    {"t":"spinner","x":16.5,"y":37.5,"hw":2,"hh":0.1,"omega":-2,"angle":0,"style":"bar"},
    {"t":"spinner","x":11.5,"y":50,"hw":6.5,"hh":0.1,"omega":-2,"angle":0,"style":"bar"},
    {"t":"spinner","x":4.5,"y":75,"hw":4,"hh":0.1,"omega":-4,"angle":0,"style":"bar"},
    {"t":"spinner","x":18.5,"y":75,"hw":4,"hh":0.1,"omega":4,"angle":0,"style":"bar"},
    {"t":"spinner","x":4.5,"y":100,"hw":5,"hh":0.1,"omega":-2.5,"angle":0,"style":"bar"},
    {"t":"spinner","x":18.5,"y":100,"hw":5,"hh":0.1,"omega":2.5,"angle":0,"style":"bar"},
    {"t":"spinner","x":4.5,"y":130,"hw":5,"hh":0.1,"omega":0.25,"angle":0,"style":"bar"},
    {"t":"spinner","x":18.5,"y":130,"hw":5,"hh":0.1,"omega":-0.32,"angle":0,"style":"bar"},
    {"t":"spinner","x":4.5,"y":140,"hw":4,"hh":0.1,"omega":0.32,"angle":-1.416,"style":"bar"},
    {"t":"spinner","x":18.5,"y":140,"hw":4,"hh":0.1,"omega":-0.32,"angle":1.416,"style":"bar"},
    {"t":"spinner","x":4.5,"y":150,"hw":5,"hh":0.1,"omega":0.32,"angle":-2.832,"style":"bar"},
    {"t":"spinner","x":18.5,"y":150,"hw":5,"hh":0.1,"omega":-0.32,"angle":2.832,"style":"bar"},
    {"t":"spinner","x":4.5,"y":160,"hw":4,"hh":0.1,"omega":0.32,"angle":2.035,"style":"bar"},
    {"t":"spinner","x":18.5,"y":160,"hw":4,"hh":0.1,"omega":-0.32,"angle":-2.035,"style":"bar"},
    {"t":"spinner","x":4.5,"y":180,"hw":6,"hh":0.1,"omega":4.6,"angle":0,"style":"bar"},
    {"t":"spinner","x":18.5,"y":180,"hw":7,"hh":0.1,"omega":-4,"angle":0,"style":"bar"},
    {"t":"spinner","x":11.5,"y":195,"hw":8,"hh":0.1,"omega":5.5,"angle":0,"style":"bar"},
  ],
};
